import MoonIcon from 'assets/lightTheme/icon-moon.svg';
import ArrowHeadIcon from 'assets/lightTheme/icon-arrowhead.svg';
import SearchIcon from 'assets/lightTheme/icon-search.svg';
import ArrowIcon from 'assets/lightTheme/icon-arrow.svg';
import NoResultsIcon from 'assets/lightTheme/icon-no-results.svg';

export const lightTheme = {
  elementBgColor: 'hsl(0, 0%, 100%)',
  bgColor: 'hsl(0, 0%, 98%)',
  shadowColor: 'hsl(0, 0%, 80%)',
  fontColor: {
    primary: 'hsl(200, 15%, 8%)',
    secondary: 'hsl(0, 0%, 52%)',
    tertiary: 'hsl(0, 0%, 70%)'
  },
  icons: {
    moon: MoonIcon,
    arrowHead: ArrowHeadIcon,
    search: SearchIcon,
    arrow: ArrowIcon,
    noResults: NoResultsIcon
  }
};
